import React from 'react';

type Formatter = (value?: number | null) => string;

export interface StopPopupContentProps {
    stopId?: string;
    stopName?: string;
    routeName?: string;
    boarding?: number | null;
    alighting?: number | null;
    load?: number | null;
    formatNumber?: Formatter;
}

const defaultFormat: Formatter = (value?: number | null) => {
    if (value === null || value === undefined) return '0';
    if (typeof value !== 'number' || Number.isNaN(value)) return '0';
    return value.toString();
};

const StopPopupContent: React.FC<StopPopupContentProps> = ({
    stopId,
    routeName,
    boarding,
    alighting,
    load,
    formatNumber = defaultFormat,
}) => {
    const metricRow = (label: string, color: string, value?: number | null) => {
        if (value === undefined || value === null) return null;
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{
                    display: 'inline-block',
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: color,
                }}/>
                <span>{label}:</span>
                <span style={{ fontWeight: 700 }}>
                    {formatNumber(value)}
                </span>
            </div>
        );
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, textAlign: 'left' }}>
            <div style={{ fontWeight: 600, opacity: 0.3 }}>{`(ID: ${stopId})`}</div>
            {routeName && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>Route:</span>
                    <span style={{ fontWeight: 600 }}>{routeName}</span>
                </div>
            )}
            {metricRow('Boardings', '#27ae60', boarding)}
            {metricRow('Alightings', '#f39c12', alighting)}
            {metricRow('Load', '#2980b9', load)}
        </div>
    );
};

export default StopPopupContent;
